import {TorchAPIConfiguration} from '../@backend/config/api.configuration';
import {environment} from '../environments/environment';

export const torchConfig: TorchAPIConfiguration = {
  rootUrl: environment.apiURL,
  filesUrl: environment.filesAPIURL
};
